var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 688,
    height: 720,
    viewBox: "0 0 688 720",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M314 0H374C379.333 0 382 2.66667 382 8V712C382 717.333 379.333 720 374 720H314C308.667 720 306 717.333 306 712V8C306 2.66667 308.667 0 314 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 322H680C685.333 322 688 324.667 688 330V390C688 395.333 685.333 398 680 398H8C2.66667 398 0 395.333 0 390V330C0 324.667 2.66667 322 8 322Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.41f920520ec750f040e653bc88448e2b.svg";
export { ForwardRef as ReactComponent };